import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [_c(VSpacer), _c(VCol, { attrs: { cols: "4" } })],
        1
      ),
      _c("v-card-widget", { attrs: { title: "Dashboard" } }, [
        _c(
          "div",
          { attrs: { slot: "widget-content" }, slot: "widget-content" },
          [_c("app-timeline", { attrs: { itens: _vm.timelineItens } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }